import styled from 'styled-components';

export const HeadContainer = styled.div`
  margin-bottom: 1.25rem;
`;

export const Subtitle = styled.p`
  font-size: 0.75rem;
  color: var(--gray-700);
`;

export const ColumnRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  button {
    margin-left: auto;
    margin-right: auto;
    margin-top: 3rem;
    margin-bottom: 4rem;
    padding: 0.7rem 1.1rem;
  }
`;

export const PermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > label {
    margin-bottom: 0.9rem;
  }

  p {
    margin-bottom: 0.5rem;
  }

  .or {
    margin-bottom: 0.9rem;
    color: var(--gray-500);
  }
`;
